export default __webpack_public_path__ + "static/media/HEALTHGRADES.09a56485.png";